import { useCallback, useState } from 'react';
import { useAuth } from '@/modules/auth/useAuth';
import { getSupabase } from '@/lib/supabase';
import {
  buildModerationActionInsert,
  type ApplyActionInput,
} from '@/modules/trust/moderation';

export type { ApplyActionInput } from '@/modules/trust/moderation';

export const useModerationActions = () => {
  const { user } = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const apply = useCallback(
    async (input: ApplyActionInput): Promise<{ ok: boolean; error?: string }> => {
      if (!user) return { ok: false, error: 'Not logged in.' };
      const supabase = getSupabase();
      if (!supabase) return { ok: false, error: 'No connection.' };

      setSubmitting(true);
      const row = buildModerationActionInsert(input, user.id, Date.now());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const db = supabase as any;
      const { error } = (await db.from('hottr_moderation_actions').insert(row)) as {
        error: { message: string } | null;
      };

      setSubmitting(false);
      if (error) return { ok: false, error: error.message };
      return { ok: true };
    },
    [user?.id],
  );

  return { apply, submitting };
};
